const state = {
    loginType: "", // 当前登录方式(确保绑定完手机号回到手机号登陆)
  };
  
  const mutations = {
    SET_LOGINTYPE: (state, loginType) => {
      state.loginType = loginType;
    },
  };
  
  const actions = {
    
  };
  
  export default {
    state,
    mutations,
    actions,
  };
  